import React from 'react';

export const NotFound = () => {
  return (
    <div className='flex flex-col h-screen'>
      <p className='text-xl text-center text-white'>Not Found</p>
    </div>
  );
};
